module.exports = __webpack_public_path__ + "img/w3_circle_trash_dark.0fa4026e.png";